import { TripRequestLogsSort } from '../../../enums';

export interface ITripRequestLogsArgs {
    page: number;
    limit?: number;
    filter?: string;
    sort?: TripRequestLogsSort[];
    from?: string;
    to?: string;
}
